import { useState } from 'react';
import { ResolutionInput } from '../FramingChart/types';
import { CustomResolutionInput } from './CustomResolutionInput';
import { Toggle } from '@hawkins/components';
import { createResolutionFromValues } from '../utilities/createResolution';

type EffectiveCanvasInputProps = {
  effectiveCanvas: ResolutionInput;
  setEffectiveCanvas: (resolution: ResolutionInput) => void;
};

export const EffectiveCanvasInput = ({
  effectiveCanvas,
  setEffectiveCanvas,
}: EffectiveCanvasInputProps) => {
  const { width, height } = effectiveCanvas;

  const hasEffectiveCanvas =
    createResolutionFromValues(width, height) != null;

  const [showEffectiveCanvasInputs, setShowEffectiveCanvasInputs] =
    useState<boolean>(hasEffectiveCanvas);

  return (
    <>
      <Toggle
        aria-label="Toggle Effective Canvas Resolution Input"
        checked={showEffectiveCanvasInputs}
        label="Effective Canvas"
        onChange={(_event, checked) => {
          setShowEffectiveCanvasInputs(checked);
          setEffectiveCanvas({ width: null, height: null });
        }}
      />

      {showEffectiveCanvasInputs && (
        <CustomResolutionInput
          customHeight={effectiveCanvas.height}
          customWidth={effectiveCanvas.width}
          onChange={setEffectiveCanvas}
        />
      )}
    </>
  );
};
